import { ActionType, createStandardAction, getType } from "typesafe-actions";

export enum UploadState {
  Idle,
  Uploading,
  Stopping
}

export enum EnabledState {
  Enabled,
  Disabled,
  Enabling,
  Disabling,
  Failed,
  Loading
}

export type State = {
  uploadState: UploadState;
  enabledState: EnabledState;
  downloadLink: string;
  uploadedOn: string;
  lastUploadRequestTime: string;
  uploadTimeout: number;
  uploadFailed: boolean;
};

export const initialState: State = {
  uploadState: UploadState.Idle,
  enabledState: EnabledState.Failed,
  downloadLink: "",
  uploadedOn: "",
  lastUploadRequestTime: "",
  uploadTimeout: 0,
  uploadFailed: false
};

export const Actions = {
  updateUploadState: createStandardAction("UpdateUploadState")<UploadState>(),
  updateEnabledState: createStandardAction("UpdateEnabledState")<
    EnabledState
  >(),
  updateLinkAndTime: createStandardAction("UpdateLinkAndTime")<
    Pick<State, "downloadLink" | "uploadedOn">
  >(),
  updateWaitingAndRequest: createStandardAction("UpdateWaitingAndRequest")<
    Pick<State, "lastUploadRequestTime" | "uploadState" | "uploadTimeout">
  >(),
  updateUploadFailed: createStandardAction("UpdateUploadFailed")<boolean>()
};

export type ActionTypes = typeof Actions;

export function reducer(state: State, a: ActionType<ActionTypes>): State {
  switch (a.type) {
    case getType(Actions.updateUploadState):
      return {
        ...state,
        uploadState: a.payload,
        uploadTimeout: 0
      };
    case getType(Actions.updateEnabledState):
      return {
        ...state,
        enabledState: a.payload
      };
    case getType(Actions.updateLinkAndTime):
      return {
        ...state,
        ...a.payload
      };
    case getType(Actions.updateWaitingAndRequest):
      return {
        ...state,
        ...a.payload,
        downloadLink: "",
        uploadedOn: ""
      };
    case getType(Actions.updateUploadFailed):
      return {
        ...state,
        uploadFailed: a.payload,
        uploadTimeout: 0
      };
  }
}
